import i18n from '@/plugins/i18n/index.js'

export default function transTypes () {
  return [
    { category: i18n.t('general.eventCategoryAcademic'), label: 'academic' },
    { category: i18n.t('general.eventCategoryHobbies'), label: 'hobbies' },
    { category: i18n.t('general.eventCategoryArts'), label: 'arts' },
    { category: i18n.t('general.eventCategoryScience'), label: 'science' },
    { category: i18n.t('general.eventCategoryCinema'), label: 'cinema' },
    { category: i18n.t('general.eventCategoryCars'), label: 'cars' },
    { category: i18n.t('general.eventCategoryCommunities'), label: 'communities' },
    { category: i18n.t('general.eventCategorySports'), label: 'sports' },
    { category: i18n.t('general.eventCategoryHolidays'), label: 'holidays' },
    { category: i18n.t('general.eventCategoryFamily'), label: 'family' },
    { category: i18n.t('general.eventCategoryGastronomy'), label: 'gastronomy' },
    { category: i18n.t('general.eventCategoryPolitics'), label: 'politics' },
    { category: i18n.t('general.eventCategoryHousing'), label: 'housing' },
    { category: i18n.t('general.eventCategoryFashion'), label: 'fashion' },
    { category: i18n.t('general.eventCategoryMusic'), label: 'music' },
    { category: i18n.t('general.eventCategoryBusiness'), label: 'business' },
    { category: i18n.t('general.eventCategorySocial'), label: 'social' },
    { category: i18n.t('general.eventCategoryOther'), label: 'other' },
    { category: i18n.t('general.eventCategoryReligion'), label: 'religion' },
    { category: i18n.t('general.eventCategoryHealth'), label: 'health' },
    { category: i18n.t('general.eventCategoryOutdoors'), label: 'outdoors' }

    // { category: i18n.t('general.eventCategoryAcademic'), value: 1, label: 'academic' },
    // { category: i18n.t('general.eventCategoryHobbies'), value: 2, label: 'hobbies' },
    // { category: i18n.t('general.eventCategoryArts'), value: 3, label: 'arts' },
    // { category: i18n.t('general.eventCategoryScience'), value: 4, label: 'science' },
    // { category: i18n.t('general.eventCategoryCinema'), value: 5, label: 'cinema' },
    // { category: i18n.t('general.eventCategoryCars'), value: 6, label: 'cars' },
    // { category: i18n.t('general.eventCategoryCommunities'), value: 7, label: 'communities' },
    // { category: i18n.t('general.eventCategorySports'), value: 8, label: 'sports' },
    // { category: i18n.t('general.eventCategoryHolidays'), value: 9, label: 'holidays' },
    // { category: i18n.t('general.eventCategoryFamily'), value: 10, label: 'family' },
    // { category: i18n.t('general.eventCategoryGastronomy'), value: 11, label: 'gastronomy' },
    // { category: i18n.t('general.eventCategoryPolitics'), value: 12, label: 'politics' },
    // { category: i18n.t('general.eventCategoryHousing'), value: 13, label: 'housing' },
    // { category: i18n.t('general.eventCategoryFashion'), value: 14, label: 'fashion' },
    // { category: i18n.t('general.eventCategoryMusic'), value: 15, label: 'music' },
    // { category: i18n.t('general.eventCategoryBusiness'), value: 16, label: 'business' },
    // { category: i18n.t('general.eventCategorySocial'), value: 17, label: 'social' },
    // { category: i18n.t('general.eventCategoryOther'), value: 18, label: 'other' },
    // { category: i18n.t('general.eventCategoryReligion'), value: 19, label: 'religion' },
    // { category: i18n.t('general.eventCategoryHealth'), value: 20, label: 'health' },
    // { category: i18n.t('general.eventCategoryOutdoors'), value: 21, label: 'outdoors' }
  ]
}
